export default __webpack_public_path__ + "static/media/investors_logo1.b99493ff.png";